import * as z from "zod";

const validationSchema = z.object({
  id: z.number({ message: "validation:languageRequired" }).int().nonnegative(),
  name: z.string({ message: "validation:languageRequired" }).min(1, { message: "validation:languageRequired" }),
  languageCode: z.string({ message: "validation:languageRequired" }).min(1),
});

export const LanguageValidationSchema = validationSchema;
export type LanguageFormInput = z.infer<typeof LanguageValidationSchema>;
